// Key is route.path and value is list of all parent, sorted from highest to lowest
export const sitemap = {}